interface OrganizationInvitationParams {
  organizationName: string;
  invitationUrl: string;
}

export const organizationInvitationEmail = ({
  organizationName,
  invitationUrl,
}: OrganizationInvitationParams) => ({
  subject: `You've been invited to join ${organizationName} - Data Revival`,
  html: `
    <!DOCTYPE html>
    <html>
      <head>
        <meta charset="utf-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
      </head>
      <body style="margin: 0; padding: 0; background-color: #f3f4f6; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;">
        <table role="presentation" width="100%" cellspacing="0" cellpadding="0" style="background-color: #f3f4f6;">
          <tr>
            <td align="center" style="padding: 40px 20px;">
              <table role="presentation" width="600" cellspacing="0" cellpadding="0" style="max-width: 600px; width: 100%;">

                <!-- Header -->
                <tr>
                  <td align="center" style="padding-bottom: 32px;">
                    <img src="https://app.data-revival.com/DataRevival_FC_RGB.png" alt="Data Revival" height="32" style="display: block;">
                  </td>
                </tr>

                <!-- Main Card -->
                <tr>
                  <td style="background-color: #ffffff; border-radius: 12px; box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);">
                    <table role="presentation" width="100%" cellspacing="0" cellpadding="0">

                      <!-- Card Content -->
                      <tr>
                        <td style="padding: 40px 40px 32px 40px;">
                          <h1 style="margin: 0 0 24px 0; font-size: 24px; font-weight: 600; color: #111827; line-height: 1.3;">
                            You've been invited to join ${organizationName}
                          </h1>
                          <p style="margin: 0 0 24px 0; font-size: 16px; color: #4b5563; line-height: 1.6;">
                            You have been invited to join <strong style="color: #111827;">${organizationName}</strong> on Data Revival.
                          </p>
                          <p style="margin: 0; font-size: 16px; color: #4b5563; line-height: 1.6;">
                            Click the button below to accept the invitation and join the organisation:
                          </p>
                        </td>
                      </tr>

                      <!-- CTA Button -->
                      <tr>
                        <td align="center" style="padding: 0 40px 32px 40px;">
                          <a href="${invitationUrl}" style="display: inline-block; background-color: #1d365d; color: #ffffff; font-size: 16px; font-weight: 600; text-decoration: none; padding: 14px 32px; border-radius: 8px;">
                            Accept Invitation
                          </a>
                        </td>
                      </tr>

                      <!-- Fallback Link -->
                      <tr>
                        <td style="padding: 0 40px 24px 40px;">
                          <p style="margin: 0; font-size: 14px; color: #6b7280; line-height: 1.6;">
                            Or copy and paste this link into your browser:
                          </p>
                          <p style="margin: 8px 0 0 0; font-size: 14px; line-height: 1.6;">
                            <a href="${invitationUrl}" style="color: #1d365d; word-break: break-all; text-decoration: none;">${invitationUrl}</a>
                          </p>
                        </td>
                      </tr>

                      <!-- Expiration Notice -->
                      <tr>
                        <td style="padding: 0 40px 40px 40px;">
                          <p style="margin: 0; font-size: 14px; color: #6b7280; line-height: 1.6;">
                            This invitation will expire in 24 hours.
                          </p>
                        </td>
                      </tr>

                    </table>
                  </td>
                </tr>

                <!-- Footer -->
                <tr>
                  <td style="padding: 32px 20px; text-align: center;">
                    <p style="margin: 0 0 8px 0; font-size: 14px; color: #6b7280; line-height: 1.5;">
                      Best regards,<br>
                      The Data Revival Team
                    </p>
                    <p style="margin: 16px 0 0 0; font-size: 12px; color: #9ca3af;">
                      &copy; ${new Date().getFullYear()} Data Revival Ltd. All rights reserved.
                    </p>
                  </td>
                </tr>

              </table>
            </td>
          </tr>
        </table>
      </body>
    </html>
  `,
  text: `You've been invited to join ${organizationName}

You have been invited to join ${organizationName} on Data Revival.

Click the link below to accept the invitation and join the organisation:
${invitationUrl}

This invitation will expire in 24 hours.

Best regards,
The Data Revival Team

© ${new Date().getFullYear()} Data Revival Ltd. All rights reserved.`,
});
